var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},_vm._l((Array(_vm.dotsCount).fill(0)),function(dot,index){return _c('div',{key:dot+'_'+index+'_',staticClass:"dot",class:{'active-dot': _vm.currentStep === index + 1}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }